import { css } from '@emotion/react'
import { Button, Cell, Grid, Icon, Tooltip } from 'bold-ui'
import { blue } from 'bold-ui/lib/styles/colors'
import { DateField } from 'components/form'
import { max } from 'lodash'
import { Fragment } from 'react'
import { isUndefinedOrNull } from 'util/checks'
import { MetaPath } from 'util/metaPath'

import {
  CardResultadoExameContainer,
  getCardResultadoExameStatus,
} from '../../../resultados-exames/adicionar/components/CardResultadoExameContainer'
import { ResultadoExameExpandableContainer } from '../../../resultados-exames/adicionar/components/ResultadoExameExpandableContainer'
import { ResultadoExameTextAreaField } from '../../../resultados-exames/adicionar/components/ResultadoExameTextAreaField'
import { ResultadoExameAnexoFormModel } from '../../model-anexoArquivos'
import { convertToExameQueryModel } from './converter-examesSolicitados'

interface ExameAccordionProps {
  name: MetaPath<ResultadoExameAnexoFormModel>
  remove: () => ResultadoExameAnexoFormModel
  value: ResultadoExameAnexoFormModel
  dataInicioAtendimento: Date
  dataRealizado: Date
  dataSolicitado: Date
  dataNascimento: Date
  isSolicitado: boolean
  errors?: {
    ignoringTouchedAndDirtyErrors: boolean
    allErrors: boolean
  }
}

export function ExameAccordion(props: Readonly<ExameAccordionProps>) {
  const {
    name,
    remove,
    value,
    dataRealizado,
    dataSolicitado,
    dataNascimento,
    dataInicioAtendimento,
    isSolicitado,
    errors = {
      ignoringTouchedAndDirtyErrors: false,
      allErrors: false,
    },
  } = props

  return (
    <CardResultadoExameContainer
      headerWidgets={
        isSolicitado ? (
          <Tooltip
            text={`Solicitação de ${value.dataSolicitacao} por ${value.nomeProfissional} | ${value.cbo} | ${value.nomeUnidadeSaude}`}
            placement='auto'
          >
            <Icon icon='calendarFilled' size={1} color={blue.c40} />
          </Tooltip>
        ) : null
      }
      headerDates={{ dataRealizado: value.dataRealizado, dataResultado: value.dataResultado }}
      headerButtons={
        <Tooltip text='Excluir'>
          <Button
            skin='ghost'
            size='small'
            style={css`
              margin: -0.5rem 0;
            `}
            onClick={remove}
          >
            <Icon icon='trashOutline' fill='normal' />
          </Button>
        </Tooltip>
      }
      exame={convertToExameQueryModel(value)}
      status={getCardResultadoExameStatus(value, errors?.allErrors)}
      ignoringTouchedAndDirtyStatus={getCardResultadoExameStatus(value, errors?.ignoringTouchedAndDirtyErrors)}
    >
      {({ expanded }) => (
        <Fragment>
          <ResultadoExameTextAreaField
            name={name.resultado}
            expanded={expanded}
            hasValue={isSolicitado ? false : !isUndefinedOrNull(value.resultado)}
          />

          <ResultadoExameExpandableContainer expanded={expanded}>
            <Grid gap={1.5}>
              {!isSolicitado && (
                <Fragment>
                  <Cell size={5}>
                    <DateField
                      name={name.dataSolicitacao}
                      label='Solicitado em'
                      minDate={dataNascimento}
                      maxDate={dataInicioAtendimento}
                      inline
                    />
                  </Cell>
                  <Cell size={7} />
                </Fragment>
              )}

              <Cell size={5}>
                <DateField
                  name={name.dataRealizado}
                  label='Realizado em'
                  minDate={max([dataNascimento, dataSolicitado])}
                  maxDate={dataInicioAtendimento}
                  required
                  inline
                />
              </Cell>

              <Cell size={5}>
                <DateField
                  name={name.dataResultado}
                  label='Resultado em'
                  inline
                  minDate={max([dataNascimento, dataRealizado])}
                  maxDate={dataInicioAtendimento}
                />
              </Cell>
            </Grid>
          </ResultadoExameExpandableContainer>
        </Fragment>
      )}
    </CardResultadoExameContainer>
  )
}
